.root {
	background-color: #ffffff;
	width: fit-content;
	height: fit-content;
}
